
<!-- Header -->
<div class="row row-product-table row-bottom-bordered">
  <div class="col col-xxl-4 col-xl-5 col-lg-5 col-product text-left product-table-header">{{ 'orders.product' | translate }}</div>
  <div class="col col-xxl-2 d-none d-xxl-block col-color text-left product-table-header">{{ 'details.color' | translate }}</div>
  <div class="col col-xxl-1 d-none d-xxl-block col-size text-left product-table-header">{{ 'details.size' | translate }}</div>
  <div class="col col-xxl-1 col-xl-2 col-lg-2 d-none d-lg-block col-price text-right product-table-header">{{ 'details.price' | translate }}</div>
  <div class="col col-xxl-2 col-xl-2 col-lg-2 d-none d-lg-block col-stock text-left product-table-header">{{ 'details.stock' | translate }}</div>
  <div class="col col-xxl-2 col-xl-3 col-lg-3 col-action text-left product-table-header"><!-- action --></div>
</div>

<app-product-table-item *ngFor="let product of products"
  [product]="product"
  [isFavorite]="isFavorite(product)"
  [combinedFacets]="combinedFacets"
  [catalogItemPageSettings]="catalogItemPageSettings"
  [cartProduct]="cartProduct(product)"
  [quantityPicker]="quantityPicker"
  [allowOutOfStockOrdering]="allowOutOfStockOrdering"
  (onDetails)="openDetails($event)"
  (onFavoriteToggle)="toggleFavorite($event)"
  (onAddCart)="addCart($event)">
</app-product-table-item>
